import { NavItemType } from '../../../berry/types';
import { GeneralPlatformProperties } from 'controller/properties/PropertyDefinition';

import {
    EventAvailable,
    ListAlt,
    PeopleAlt,
    InsertInvitation,
    Analytics,
    Hardware,
    Person4,
    ContactPage,
    Dashboard,
    Storefront
} from '@mui/icons-material';

const icons = {
    Dashboard,
    EventAvailable,
    ListAlt,
    PeopleAlt,
    InsertInvitation,
    Analytics,
    Hardware,
    Person4,
    ContactPage,
    Storefront
};

// TODO -> Add an user level property here or a property driven string for auth nav items

const menuDefinition: NavItemType[] = [
    // {
    //     id: 'dashboard',
    //     title: 'Dashboard',
    //     type: 'item',
    //     url: '/dashboard',
    //     icon: icons.Dashboard,
    //     breadcrumbs: false
    // },
    {
        id: 'tasks',
        title: 'Tasks',
        type: 'item',
        url: '/tasks',
        icon: icons.EventAvailable,
        breadcrumbs: false,
        authorization: GeneralPlatformProperties.Tasks
    },
    {
        id: 'companies',
        title: 'Companies',
        type: 'item',
        url: '/companies',
        icon: icons.Storefront,
        breadcrumbs: false,
        authorization: GeneralPlatformProperties.Companies
    },
    {
        id: 'companies',
        title: 'Company Dashboard',
        type: 'item',
        url: '/company',
        icon: icons.Storefront,
        breadcrumbs: false,
        authorization: GeneralPlatformProperties.CompanyDashboard
    },
    {
        id: 'jobs',
        title: 'Jobs',
        type: 'item',
        url: '/jobs',
        icon: icons.ListAlt,
        breadcrumbs: false,
        authorization: GeneralPlatformProperties.Jobs
    },
    {
        id: 'candidates',
        title: 'Candidates',
        type: 'item',
        url: '/candidates',
        icon: icons.PeopleAlt,
        breadcrumbs: false,
        authorization: GeneralPlatformProperties.Candidates
    },
    {
        id: 'onboarding',
        title: 'Onboarding',
        type: 'item',
        url: '/onboarding',
        icon: icons.Analytics,
        breadcrumbs: false,
        authorization: GeneralPlatformProperties.Onboarding
    },
    {
        id: 'teams',
        title: 'Teams',
        type: 'item',
        url: '/teams',
        icon: icons.InsertInvitation,
        breadcrumbs: false,
        authorization: GeneralPlatformProperties.Teams
    },
    // {
    //     id: 'employees',
    //     title: 'Employees',
    //     type: 'item',
    //     url: '/employees',
    //     icon: icons.Hardware,
    //     breadcrumbs: false
    // },
    {
        id: 'user',
        title: 'User',
        type: 'item',
        url: '/users',
        icon: icons.Person4,
        breadcrumbs: false,
        authorization: GeneralPlatformProperties.Users
    }
];

export default menuDefinition;
